/**
 * Polyfills ({@link https://www.selerix.com})
 * This is unpublished proprietary source code of Selerix Systems, Inc. The
 * copyright notice above is not evidence any actual or intended
 * publication of such source code.
 * @copyright Copyright 2025 Selerix Systems, Inc. All Rights Reserved.
 */

(function stringPolyfills(s) {
	'use strict';

	if (!s.prototype.includes) {
		s.prototype.includes = function includes(search, start) {
			if (search === '') {
				return true;
			}
			if (typeof start !== 'number') {
				start = 0;
			}
			if (start + search.length > this.length) {
				return false;
			} else {
				return this.indexOf(search, start) !== -1;
			}
		};
	}
	if (!s.prototype.startsWith) {
		s.prototype.startsWith = function startsWith(searchString, position) {
			position = Math.max(0, position || 0);
			return this.substr(position, searchString.length) === searchString;
		};
	}
	if (!s.prototype.endsWith) {
		s.prototype.endsWith = function endsWith(searchString, position) {
			if (searchString === '') {
				return true;
			}
			var subjectString = this.toString();
			if (position === undefined || position > subjectString.length) position = subjectString.length;
			position -= searchString.length;
			var lastIndex = subjectString.indexOf(searchString, position);
			return lastIndex !== -1 && lastIndex === position;
		};
	}
	if (!s.prototype.remove) {
		s.prototype.remove = function remove(i) {
			if (this === null || this === void 0) return this;
			return this.substring(0, i);
		};
	}
	if (!s.prototype.removeLast) {
		s.prototype.removeLast = function removeLast(searchString) {
			if (this === null || this === void 0) return this;
			var lastIndex = this.lastIndexOf(searchString);
			return ~lastIndex
				? this.remove(lastIndex)
				: this; // return the original string (remove nothing) if `searchString` was not found
		};
	}
	if (!s.prototype.replaceAt) {
		s.prototype.replaceAt = function replaceAt(startIndex, replace) {
			var startIndex = Math.max(startIndex, 0);
			return this.substr(0, startIndex) + replace + this.substr(startIndex + replace.length);
		};
	}
	if (!s.prototype.replaceAll) {
		s.prototype.replaceAll = function replaceAll(searchString, replaceString) {
			if (searchString !== '') {
				return this.split(searchString).join(replaceString);
			}
			if (this === '') {
				return replaceString;
			}
			return replaceString + this.split(searchString).join(replaceString) + replaceString;
		};
	}
	if (!s.prototype.formatAs) {
		s.prototype.formatAs = function formatAs(format, decimals) {
			var numberValue = parseFloat(this);
			if (isNaN(numberValue)) return this;
			else return numberValue.formatAs(format, decimals);
		};
	}
	s.prototype.formatISODate = function formatISODate() {
		if (this === null || this === void 0) return this;
		return this.substring(5, 7) + '/' + this.substring(8, 10) + '/' + this.substring(0, 4);
	};
	if (!s.prototype.splice) {
		s.prototype.splice = function splice(startIndex, replaceCount, replacementString) {
			var start = startIndex >= 0 ? startIndex : 0;
			return this.slice(0, start) + replacementString + this.slice(start + Math.abs(replaceCount));
		};
	}
	// mark all substrings matching pattern
	if (!s.prototype.mark) {
		s.prototype.mark = function mark(pattern) {
			if (this.toLowerCase().startsWith(pattern.toLowerCase())) {
				var esc = pattern.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
				var reg = new RegExp(esc, 'ig');
				return this.replace(reg, function replace(match) {
					return '<mark>' + match + '</mark>';
				});
			} else {
				return this;
			}
		};
	}
	s.prototype.toBool = function toBool() {
		return this === true || this.toLowerCase() === 'true';
	};
	if (!s.prototype.isValidDate) {
		s.prototype.isValidDate = function isValidDate() {
			var matches = /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/.exec(this);
			if (matches === null) return false;
			var d = +matches[2];
			var m = +matches[1] - 1;
			var y = +matches[3];
			var composedDate = new Date(y, m, d);
			return composedDate.getDate() === d &&
				composedDate.getMonth() === m &&
				composedDate.getFullYear() === y;
		};
	}
	if (!s.prototype.padStart) {
		s.prototype.padStart = function padStart(targetLength, padString) {
			targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
			padString = s((typeof padString !== 'undefined' ? padString : ' '));
			if (this.length > targetLength) {
				return s(this);
			} else {
				targetLength = targetLength - this.length;
				if (targetLength > padString.length) {
					padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
				}
				return padString.slice(0, targetLength) + s(this);
			}
		};
	}
	if (!s.prototype.padEnd) {
		s.prototype.padEnd = function padEnd(targetLength, padString) {
			targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
			padString = s((typeof padString !== 'undefined' ? padString : ' '));
			if (this.length > targetLength) {
				return s(this);
			} else {
				targetLength = targetLength - this.length;
				if (targetLength > padString.length) {
					padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
				}
				return s(this) + padString.slice(0, targetLength);
			}
		};
	}
	if (!s.prototype.repeat) {
		s.prototype.repeat = function repeat(count) {
			if (this == null) {
				throw new TypeError('can\'t convert ' + this + ' to object');
			}
			var str = '' + this;
			count = +count;
			if (count != count) {
				count = 0;
			}
			if (count < 0) {
				throw new RangeError('repeat count must be non-negative');
			}
			if (count == Infinity) {
				throw new RangeError('repeat count must be less than infinity');
			}
			count = Math.floor(count);
			if (str.length == 0 || count == 0) {
				return '';
			}
			// Ensuring count is a 31-bit integer allows us to heavily optimize the
			// main part. But anyway, most current (August 2014) browsers can't handle
			// strings 1 << 28 chars or longer, so:
			if (str.length * count >= 1 << 28) {
				throw new RangeError('repeat count must not overflow maximum string size');
			}
			var maxCount = str.length * count;
			count = Math.floor(Math.log(count) / Math.log(2));
			while (count) {
				str += str;
				count--;
			}
			str += str.substring(0, maxCount - str.length);
			return str;
		};
	}
})(String);

Boolean.prototype.toBool = function toBool() {
	return this.valueOf();
};

(function numberPolyfills(n) {
	'use strict';

	n.prototype.formatAs = function formatAs(format, decimals, thousandsDelimiterCount, thousandsDelimiter, decimalDelimiter) {
		var value = this.valueOf();
		switch (format) {
			case 'money':
			case 'numeric':
			case 'percentage':
			{
				thousandsDelimiterCount = thousandsDelimiterCount || 3;
				thousandsDelimiter = thousandsDelimiter || ',';
				decimalDelimiter = decimalDelimiter || '.';
				if (format === 'money') {
					decimals = decimals === null || decimals === void 0 ? 2 : decimals;
				} else if (format === 'percentage') {
					value *= value < 1 ? 100 : 1;
				}
				var exp = '\\d(?=(\\d{' + thousandsDelimiterCount + '})+' + (decimals > 0 ? '\\D' : '$') + ')', num = value.toFixed(Math.max(0, ~~decimals));
				var formattedValue = (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(new RegExp(exp, 'g'), '$&' + (thousandsDelimiter || ','));

				if (format === 'money') return '$' + formattedValue;
				else if (format === 'percentage') return formattedValue + '%';
				else return formattedValue;
			}

			case 'filesize':
			{
				var formats = [' B', ' KB', ' MB', ' GB', ' TB'];
				var sign = value < 0 ? -1 : 1;
				var counter = 0;
				var convertedValue = Math.abs(value);
				while (convertedValue >= 1024 && counter < formats.length - 1) {
					convertedValue /= 1024; counter++;
				}

				var m = Math.pow(1024, counter);
				if (m > 0) {
					convertedValue = convertedValue + (sign * value - (convertedValue * m)) / m;
				}

				var f = formats[counter];
				return (sign * (Math.round(convertedValue * 100) / 100)) + f;
			}

			default:
				return this + '';
		}

	};

	// Number.parseFloat
	if (!n.parseFloat) {
		n.parseFloat = function parseFloat(value) {
			return window.parseFloat(value);
		};
	}

	// Number.parseInt
	if (!n.parseInt) {
		n.parseInt = function parseInt(value, base) {
			return window.parseInt(value, base);
		};
	}

	// Number.isNaN
	if (!n.isNaN) {
		n.isNaN = function isNaN(value) {
			return typeof value === 'number' && window.isNaN(value);
		};
	}
})(Number);

(function datePolyfills(dt) {
	'use strict';

	function pad(n) {
		return n < 10 ? '0' + n : n;
	}
	function hours(n) {
		return n === 0 ? 12 : n > 12 ? n - 12 : n;
	}
	function meridian(n) {
		return n > 11 ? 'PM' : 'AM';
	}

	dt.prototype.toDateOnly = function toDateOnly() {
		if (!this.isValid()) {
			return this.toString(); // 'Invalid Date'
		}
		return this.getUTCFullYear() + '-'
			+ pad(this.getUTCMonth() + 1) + '-'
			+ pad(this.getUTCDate()) + 'T00:00:00';
	};

	dt.prototype.getTicks = function getTicks() {
		return ((this.getTime() * 10000) + 621355968e9);
	};

	if (!dt.prototype.defaultToString) {
		// polyfill to add optional argument to return date/time string according to specified format
		dt.prototype.defaultToString = Date.prototype.toString;
		dt.prototype.toString = function toString(format) {
			if (format === void 0) return Date.prototype.defaultToString.call(this);
			if (isNaN(this.getTime())) return 'Invalid Date';
			if (format === 'd') format = 'MM/dd/yyyy';

			var ttReplacement = '[!!]';
			var MMMReplacement = '[!!!]';
			var MMMMReplacement = '[!!!!]';

			return format
				.replace('tt', ttReplacement)
				.replace('MMMM', MMMMReplacement)
				.replace('MMM', MMMReplacement)
				.replace('dd', pad(this.getDate()))
				.replace('d', this.getDate())
				.replace('yyyy', this.getFullYear())
				.replace('HH', this.getHours())
				.replace('hh', pad(hours(this.getHours())))
				.replace('h', hours(this.getHours()))
				.replace('mm', pad(this.getMinutes()))
				.replace('ss', pad(this.getSeconds()))
				.replace('t', meridian(this.getHours()).substring(0, 1))
				.replace('MM', pad(this.getMonth() + 1))
				.replace('M', this.getMonth() + 1)
				.replace(MMMMReplacement, new Intl.DateTimeFormat('en-US', { month: 'long' }).format(this))
				.replace(MMMReplacement, new Intl.DateTimeFormat('en-US', { month: 'short' }).format(this))
				.replace(ttReplacement, meridian(this.getHours()));
		};
	}

	if (!Object.prototype.hasOwnProperty.call(dt, 'isValid')) {
		/** Verifies that the date object is valid */
		dt.prototype.isValid = function dateIsValid() {
			return Object.prototype.toString.call(this) === '[object Date]' && !isNaN(this.getTime());
		};
	}

	if (!Object.prototype.hasOwnProperty.call(dt, 'copy')) {
		/**
		 * Creates and returns a new instance of the provided date.
		 * @param {Date} date - The date to be copied.
		 * @returns {Date | undefined} Returns a Date if param 'date' is valid.
		 */
		dt.copy = function copy(date) {
			if (!(date instanceof Date)) {
				console.error('Error: Expected a date object and got "' + date + '". This method returned "undefined" as a result.');
				return;
			}
			return new Date(date.getTime());
		};
	}
})(Date);

(function arrayPolyfills(a) {
	'use strict';

	// find index of element in array for unsupported browsers
	if (!a.prototype.findIndex) {
		var findIndex = function (predicate, thisArg) {
			if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');

			var list = Object(this);
			var length = list.length >>> 0;
			var value;

			for (var i = 0; i < length; i++) {
				value = list[i];
				if (predicate.call(thisArg, value, i, list)) return i;
			}
			return -1;
		};
		Object.defineProperty(a.prototype, 'findIndex', { value: findIndex });
	}

	if (!a.prototype.entries) {
		var entries = function () {
			var counter = 0;
			var array = this;

			return {
				next: function () {
					return counter < array.length
						? { value: [counter, array[counter++]], done: false }
						: { value: undefined, done: true };
				}
			};
		};
		Object.defineProperty(a.prototype, 'entries', { value: entries });
	}

	// check if any occurrence exists in array
	if (!a.prototype.any) {
		var any = function any(predicate) {
			return this.findIndex(predicate) > -1;
		};
		Object.defineProperty(a.prototype, 'any', { value: any });
	}

	// find item in array for unsupported browsers
	if (!a.prototype.find) {
		var find = function find(predicate) {
			var i = this.findIndex(predicate);
			return i > -1 ? this[i] : undefined;
		};
		Object.defineProperty(a.prototype, 'find', { value: find });
	}

	if (!a.prototype.toSorted) {
		var toSorted = function toSorted(compareFn) {
			return this.slice().sort(compareFn);
		};
		Object.defineProperty(a.prototype, 'toSorted', { value: toSorted });
	}

	// static find index function of element in array for unsupported browsers
	if (!a.findIndex) {
		a.findIndex = function findIndex(arr, predicate, thisArg) {
			if (arr === null) throw new TypeError('Array.prototype.findIndex called on null or undefined');
			return arr.findIndex(predicate, thisArg);
		};
	}

	// array checker for unsupported browsers
	if (!a.isArray) {
		a.isArray = function isArray(arg) {
			return Object.prototype.toString.call(arg) === '[object Array]';
		};
	}
	// array checker for unsupported browsers
	if (!a.prototype.includes) {
		var includes = function (arg) {
			var i = this.length;
			while (i--) if (this[i] === arg) return true;
			return false;
		};
		Object.defineProperty(a.prototype, 'includes', { value: includes });
	}
	// array checker for unsupported browsers
	if (!a.prototype.contains) {
		Object.defineProperty(a.prototype, 'contains', { value: a.prototype.includes });
	}
	// filter array for unsupported browsers
	if (!a.prototype.filter) {
		var filter = function (predicate, thisArg) {
			if (this === void 0 || this === null) {
				throw new TypeError();
			}

			var t = Object(this);
			var len = t.length >>> 0;
			if (typeof predicate !== 'function') {
				throw new TypeError();
			}

			var res = [];
			for (var i = 0; i < len; i++) {
				if (i in t) {
					var val = t[i];
					if (predicate.call(thisArg, val, i, t)) {
						res.push(val);
					}
				}
			}

			return res;
		};
		Object.defineProperty(a.prototype, 'filter', { value: filter });
	}
	// static array filter for unsupported browsers
	if (!a.filter) {
		a.filter = function filter(arr, predicate) {
			if (arr === null) throw new TypeError('Array.prototype.filter called on null or undefined');
			return arr.filter(predicate);
		};
	}

	// static array from object for unsupported browsers 
	if (!a.from) {
		a.from = (function fromPolyfill() {
			var toStr = Object.prototype.toString;
			var isCallable = function (fn) {
				return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
			};
			var toInteger = function (value) {
				var number = Number(value);
				if (isNaN(number)) {
					return 0;
				}
				if (number === 0 || !isFinite(number)) {
					return number;
				}
				return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
			};
			var maxSafeInteger = Math.pow(2, 53) - 1;
			var toLength = function (value) {
				var len = toInteger(value);
				return Math.min(Math.max(len, 0), maxSafeInteger);
			};

			function arrayFromIterator(iterator, mapFunction) {
				var result = [];

				var item;
				// eslint-disable-next-line no-cond-assign
				while (item = iterator.next()) {
					if (item.done) {
						break;
					}
					if (mapFunction === undefined) {
						result.push(item.value);
					} else {
						result.push(mapFunction(item.value));
					}
				}

				return result;
			}

			return function from(arrayLike, mapFunction, thisArg) {
				var thisObject = this;
				var items = Object(arrayLike);

				if (arrayLike == null) {
					throw new TypeError('Array.from requires an array-like object - not null or undefined');
				}

				if (typeof mapFunction !== 'undefined' && !isCallable(mapFunction)) {
					throw new TypeError('Array.from: when provided, the second argument must be a function');
				}

				if (!Array.isArray(arrayLike)) {
					if ('next' in arrayLike && typeof arrayLike.next === 'function') {
						return arrayFromIterator(arrayLike, mapFunction);
					}
					if ('Set' in window && arrayLike instanceof window.Set) {
						return arrayFromIterator(arrayLike.values(), mapFunction);
					}
					if ('entries' in arrayLike && typeof arrayLike.entries === 'function') {
						return arrayFromIterator(arrayLike.entries(), mapFunction);
					}
				}

				var len = toLength(items.length);
				var A = isCallable(thisObject) ? Object(new thisObject(len)) : new Array(len);
				var k = 0;
				var kValue;

				while (k < len) {
					kValue = items[k];
					if (mapFunction) {
						A[k] = typeof thisArg === 'undefined' ? mapFunction(kValue, k) : mapFunction.call(thisArg, kValue, k);
					} else {
						A[k] = kValue;
					}
					k += 1;
				}

				A.length = len;
				return A;
			};
		}());
	}
})(Array);

(function objectPolyfills(o) {
	'use strict';
	if (!o.values) {
		o.values = function values(obj) {
			var keys = o.keys(obj);
			var i = keys.length;
			var resultArray = new Array(i); // preallocate the Array
			while (i--)
				resultArray[i] = obj[keys[i]];

			return resultArray;
		};
	}
	if (!o.entries) {
		o.entries = function entries(obj) {
			var ownProps = o.keys(obj);
			var i = ownProps.length;
			var resultArray = new Array(i); // preallocate the Array
			while (i--)
				resultArray[i] = [ownProps[i], obj[ownProps[i]]];

			return resultArray;
		};
	}
	if (typeof o.assign !== 'function') {
		o.assign = function assign(target) {
			if (target === null || target === undefined) {
				throw new TypeError('Cannot convert undefined or null to object');
			}

			target = Object(target);
			for (var index = 1; index < arguments.length; index++) {
				var source = arguments[index];
				if (source === null || source === undefined) {
					continue;
				}

				var sourceEntries = o.entries(source);
				for (var sourceIndex = 0; sourceIndex < sourceEntries.length; sourceIndex++) {
					var kvp = sourceEntries[sourceIndex];
					var key = kvp[0];
					var value = kvp[1];
					target[key] = value;
				}
			}
			return target;
		};
	}
})(Object);

(function modernizrPolyfills(m) {
	'use strict';

	if (m.addTest && typeof m.addTest === 'function') {
		m.addTest('isie', function isie() {
			return window.ActiveXObject || 'ActiveXObject' in window ? true : false;
		});
		m.addTest('isie11', function isie11() {
			return !(window.ActiveXObject) && 'ActiveXObject' in window;
		});
		m.addTest('isedge', function isedge() {
			return navigator.userAgent.indexOf('Edge') >= 0;
		});
		m.addTest('ismicrosoft', function ismicrosoft() {
			return m.isie || m.isedge;
		});
		m.addTest('ischrome', function ischrome() {
			return navigator.userAgent.indexOf('Chrome') >= 0;
		});
	}

	var Cookie = function Cookie(id, value, options) {
		var self = this;
		self.id = id;

		options = options !== null && options !== void 0 && isNaN(options)
			? options
			: !isNaN(options)
				? { expires: options }
				: {};

		var _get = function _getCookieValue() {
			if (document.cookie.length <= 0) {
				return '';
			}

			var name = id + '=';
			var ca = document.cookie.replaceAll('; ', ';').split(';');
			var ck = ca.find(function cookieIndex(c) {
				return c.indexOf(name) >= 0;
			});
			return ck ? ck.substring(ck.indexOf('=') + 1) : '';
		};

		if (typeof (value) === 'number') {
			value = value.toString();
		}
		self.value = value || _get();
		self.expiration = options.expires || 0;

		self.get = function get() {
			return _get();
		};

		self.save = function save() {
			var exp = new Date();
			exp.setDate(exp.getDate() + self.expiration);
			document.cookie = self.id + '=' + self.value + ((exp != null && exp != void 0) ? '; expires=' + exp.toUTCString() : '') + (options.path ? '; path=' + options.path : '');
		};

		self.delete = function deleteCookie() {
			document.cookie = self.id + '=; expires=' + (new Date(0)).toUTCString() + (options.path ? '; path=' + options.path : '');
		};
	};

	var storageKeyDelimiter = ':~:';

	var CookieMap = function CookieMap(storageKeyCookieName, storageKeyCookiePrefix) {
		var listCookie = new Cookie(storageKeyCookieName, '', 1);
		var getItemKeys = function getItemKeys() {
			var cookieValue = listCookie.get();
			return cookieValue === ''
				? []
				: cookieValue.split(storageKeyDelimiter);
		};
		var escapeValue = function (value) {
			return value
				.replace(/;/g, '%3B')
				.replace(/=/g, '%3D');
		};
		var unescapeValue = function (value) {
			return value
				.replace(/%3B/g, ';')
				.replace(/%3D/g, '=');
		};
		return {
			set: function (key, value) {
				var escapedId = escapeValue(key);
				var keys = getItemKeys();
				if (!keys.includes(escapedId)) {
					keys.push(escapedId);
					listCookie.value = keys.join(storageKeyDelimiter);
					listCookie.save();
				}
				new Cookie(storageKeyCookiePrefix + escapedId, escapeValue(value), 1).save();
			},
			get: function (key) {
				var escapedId = escapeValue(key);
				if (!getItemKeys().includes(escapedId)) {
					return null;
				}
				return unescapeValue(new Cookie(storageKeyCookiePrefix + escapedId).value);
			},
			has: function (key) {
				return getItemKeys().includes(escapeValue(key));
			},
			delete: function (key) {
				var escapedId = escapeValue(key);
				var keys = getItemKeys();
				if (keys.includes(escapedId)) {
					new Cookie(storageKeyCookiePrefix + escapedId).delete();
					listCookie.value = keys
						.filter(function keyFilter(k) {
							return k !== escapedId;
						})
						.join(storageKeyDelimiter);
					listCookie.save();
				}
			},
			clear: function () {
				var keys = getItemKeys();
				for (var i = 0; i < keys.length; i++) {
					new Cookie(storageKeyCookiePrefix + keys[i]).delete();
				}
				listCookie.delete();
			},
			get length() {
				return getItemKeys().length;
			}
		};
	};

	var shouldUseLocalStorage = m.localstorage && !m.ismicrosoft;

	var nativeLocalStorage = window.localStorage;

	var localStorageMap = shouldUseLocalStorage
		? undefined
		: !navigator.cookieEnabled
			? new Map()
			: new CookieMap('__sk', 'st__');

	/** @type {string[]} */
	var storageKeys;

	var $localStorage = shouldUseLocalStorage
		? nativeLocalStorage
		: {
			setItem: function (key, value) {
				var stringValue = String(value);
				localStorageMap.set(key, stringValue);

				if (!storageKeys.includes(key)) {
					Object.defineProperty(this, key, {
						get: function () {
							return $localStorage.getItem(key);
						},
						set: function (value) {
							$localStorage.setItem(key, value);
						},
						configurable: true,
						enumerable: true
					});
				}

				// trigger storage event, if possible
				if (nativeLocalStorage) {
					nativeLocalStorage.setItem(key, value);
				}
			},
			getItem: function (key) {
				return localStorageMap.has(key) ? localStorageMap.get(key) : null;
			},
			removeItem: function (key) {
				if (!storageKeys.includes(key)) {
					delete this[key];
				}

				localStorageMap.delete(key);

				// trigger storage event, if possible
				if (nativeLocalStorage) {
					nativeLocalStorage.removeItem(key);
				}
			},
			clear: function () {
				localStorageMap.clear();

				var self = this;
				Object.keys(this).forEach(function clearLocalStorageKeys(k) {
					if (!storageKeys.includes(k)) {
						delete self[k];
					}
				});

				// trigger storage event, if possible
				if (nativeLocalStorage) {
					nativeLocalStorage.clear();
				}
			},
			get length() {
				return localStorageMap.length;
			}
		};

	storageKeys = Object.keys($localStorage);

	$.extend({
		useLocalStorage: function () {
			return shouldUseLocalStorage;
		},
		localStorage: $localStorage,
		cookie: function (name, value, options) {
			var c = new Cookie(name, value, options);
			if (value !== void 0) {
				c.save();
			}
			return c.value;
		},
		removeCookie: function (name) {
			var c = new Cookie(name);
			if (c) {
				c.delete();
			}
		}
	});

	if (!m.localstorage || m.ismicrosoft) {
		// local storage for unsupported browsers
		Object.defineProperty(window, 'localStorage', {
			value: $.localStorage, writable: false
		});
	}

	if (m.ismicrosoft) {
		// Microsoft has an opened and confirmed bug with IE/Edge not sharing localStorage across tabs/windows
		// this is fixed by adding a storage listener
		window.addEventListener('storage', function ieLocalStorageFix() { /** Hack */ });
	}

})(Modernizr || {});

(function globalPolyfills(w) {
	if (typeof w.URL !== 'function') {
		/**
		 * The URL interface represents an object providing static methods used for creating object URLs.
		 * @param {string} url The string URL to convert
		 * @returns A URL instance
		 */
		w.URL = function URL(url) {
			var protocol = url.split('//')[0];
			var comps = url.split('#')[0].replace(/^(https:\/\/|http:\/\/)|(\/)$/g, '').split('/');
			var host = comps[0];
			var search = comps[comps.length - 1].split('?')[1];
			var tmp = host.split(':');
			var port = tmp[1];
			var hostname = tmp[0];

			search = typeof search !== 'undefined' ? '?' + search : '';

			var paramParts = search
				.slice(1)
				.split('&')
				.map(function mapFunction(p) {
					return p.split('=');
				});

			var params = {};
			for (var i = 0; i < paramParts.length; i++) {
				var p = paramParts[i];
				params[p[0]] = p[1];
			}

			return {
				hash: url.indexOf('#') > -1 ? url.substring(url.indexOf('#')) : '',
				protocol: protocol,
				host: host,
				hostname: hostname,
				href: url,
				pathname: '/' + comps.splice(1).map(function mapFunction(o) {
					return /\?/.test(o) ? o.split('?')[0] : o;
				}).join('/'),
				search: search,
				origin: protocol + '//' + host,
				port: typeof port !== 'undefined' ? port : '',
				searchParams: {
					get: function (p) {
						return p in params ? params[p] : '';
					},
					getAll: function () {
						return params;
					}
				}
			};
		};
	}
})(window);

// function extensions
(function functionPolyfills(f) {
	f.evaluate = function evaluate(expression) {
		var args = Array.from(arguments).splice(1);
		return new Function('expression', 'params', 'return new Function(\'params\', expression)(params);')(expression, args);
	};
})(Function);

// modify Modernizr touch detection to include IE10+
if (Modernizr) {
	Modernizr._touch = Modernizr.touch;
	Modernizr.touch = Modernizr._touch || navigator.msPointerEnabled || navigator.maxTouchPoints > 0;
}

function fireEvent(eventName, originalEvent) {
	if (!originalEvent) return;

	var e = $.Event(eventName, {
		eventName: eventName,
		bubbles: originalEvent.bubbles,
		cancelBubble: originalEvent.cancelBubble,
		offsetX: originalEvent.offsetX,
		offsetY: originalEvent.offsetY,
		pageX: originalEvent.pageX,
		pageY: originalEvent.pageY,
		layerX: originalEvent.layerX,
		layerY: originalEvent.layerY,
		pressure: originalEvent.pressure,
		screenX: originalEvent.screenX,
		screenY: originalEvent.screenY,
		x: originalEvent.x,
		y: originalEvent.y
	});

	$(originalEvent.target).trigger(e);
}

// microsoft touch event translation
if (Modernizr && Modernizr.touch) {
	window.addEventListener('pointerdown', function pointerDownHandler(event) {
		if (event.pointerType === 'touch') fireEvent('touchstart', event);
	});
	window.addEventListener('pointermove', function pointerMoveHandler(event) {
		if (event.pointerType === 'touch') fireEvent('touchmove', event);
	});
	window.addEventListener('pointerup', function pointerUpHandler(event) {
		if (event.pointerType !== 'touch') return;
		fireEvent('touchend', event);
		fireEvent('touchleave', event);
	});
}

(function elementPolyfills(el) {
	'use strict';

	if (Modernizr && Modernizr.isedge
		&& el.prototype.addEventListener && el.prototype.removeEventListener) {
		el.prototype._removeEventListenerNative = el.prototype.removeEventListener;
		el.prototype.removeEventListener = function removeEventListener(type, listener, options) {
			if (listener) {
				el.prototype._removeEventListenerNative.call(this, type, listener, options);
			}
		};
	}
})(Element || {});

/*
 * jQuery Extensions
 */
(function jQueryExtensions($) {
	'use strict';

	// override jquery focus to first vertically center element
	$.fn.focusScroll = function focusScroll() {
		if (this.length === 0) return this;

		var t = $(this).offset().top, w = $(window), h = w.height() / 2, d = $(document);
		if (t < d.scrollTop() + 100 || t > d.scrollTop() + w.height()) {
			var v = t < h * 2 ? (t - h) / 2 : t - h;
			$(document).scrollTop(v);
		}
		return $.fn.focus.apply(this, arguments);
	};

	$.fn.extend({
		// remove whitespace nodes between child elements
		cleanWhiteSpace: function () {
			this.contents().filter(function whitespaceFilter() {
				return (this.nodeType === 3 && !/\S/.test(this.nodeValue));
			}).remove();
			return this;
		},
		optionGroupify: function () {
			$(this).each(function optionGroupifyEach() {
				var el = $(this);

				if (!el.children('optgroup').length) {
					var groups = [];

					for (var i = 0; i < el.children('option').length; i++) {
						var option = el.children('option')[i];

						var group = $(option).data('group') || undefined;

						if (group && groups.indexOf(group) < 0) {
							groups.push(group);
						}
					}

					for (var i = 0; i < groups.length; i++) {
						el.children('option[data-group="' + groups[i] + '"]')
							.wrapAll('<optgroup label="' + groups[i] + '">');
					}
				}
			});
		}
	});
	$.extend({
		ajaxUpload: function (settings) {
			settings = settings || {};
			settings.type = settings.type || 'POST';
			settings.dataType = 'json';
			settings.cache = false;
			settings.processData = false;
			settings.contentType = false;

			var _download = settings.progress;
			delete settings.progress;

			var _upload = settings.progressUpload;
			delete settings.progressUpload;

			settings.xhr = function xhr() {
				var req = $.ajaxSettings.xhr();
				if (typeof (_download) === 'function') {
					req.addEventListener('progress', _download, false);
				}
				if (req.upload && typeof (_upload) === 'function') {
					req.upload.addEventListener('progress', _upload, false);
				}
				return req;
			};

			return $.ajax(settings);
		},
		timeSpan: function (date1, date2) {
			var elapsed = Math.round((date2 - date1) / 1000);

			var h = Math.round(elapsed / 60 / 60);
			var m = Math.round((elapsed - (h * 60 * 60)) / 60);
			var s = elapsed - (h * 60 * 60) - (m * 60);

			return (elapsed < 0 ? '-' : '') + $.zeroPad(h, 2) + ':' + $.zeroPad(m, 2) + ':' + $.zeroPad(s, 2);
		},
		zeroPad: function (val, size) {
			if (val === null || val === void 0) {
				val = '';
			} else if (typeof (val) !== 'string') {
				val = val.toString();
			}

			size = size || 0;
			while (val.length < size) {
				val = '0' + val;
			}
			return val;
		}
	});
})(window.minQuery || window.jQuery);

// scoped CSS selectors for unsupported browsers
(function cssPolyfills(e) {
	try {
		document.querySelector(':scope');
	} catch (ex) {
		var _querySelector = e.prototype.querySelector;
		var _querySelectorAll = e.prototype.querySelectorAll;

		var _convertQuery = function (el, s) {
			if (!s) {
				return s;
			}
			if (s.indexOf(':scope') > -1) {
				if (!el.id) {
					el.id = $ && $.slxGuid ? 'el' + $.slxGuid().segment(4) : 'el' + (Math.floor((Math.random() * 10000) + 1));
				}
				s = s.replaceAll(':scope', '#' + el.id);
			}
			return s;
		};

		e.prototype.querySelector = function querySelector(s) {
			var str = _convertQuery(this, s);
			return _querySelector.call(this, str);
		};
		e.prototype.querySelectorAll = function querySelectorAll(s) {
			var str = _convertQuery(this, s);
			return _querySelectorAll.call(this, str);
		};
	}
})(Element);
